// src/components/ToolText.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ToolText.css";
import { getIcon } from "../../../utils/icons";
import {
  setCommandType,
  resetOperation,
  setCommandMessage,
  setTextOptions,
} from "../../../redux/operationSlice";
import { COMMANDS } from "../../../utils/commonProperties";

const ToolText = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [font, setFont] = useState("Arial");
  const [fontSize, setFontSize] = useState("12");
  const [alignment, setAlignment] = useState("left");
  const [bold, setBold] = useState(false);
  const [italic, setItalic] = useState(false);
  const [underline, setUnderline] = useState(false);
  const [color, setColor] = useState("#ffffff");

  const buttonSize = 30;
  const dispatch = useDispatch();
  const commandType = useSelector((state) => state.operation.commandType);

  useEffect(() => {
    if (commandType === COMMANDS.DRAW_SINGLE_LINE_TEXT) {
      setActiveButton("singleLine");
    } else if (commandType === COMMANDS.DRAW_MTEXT) {
      setActiveButton("mtext");
    } else {
      setActiveButton(null);
    }
  }, [commandType]);

  const handleClick = (tool) => {
    const alreadyActive = tool === activeButton;
    if (alreadyActive) {
      dispatch(resetOperation());
      setActiveButton(null);
    } else {
      setActiveButton(tool);
      if (tool === "singleLine") {
        dispatch(setCommandType(COMMANDS.DRAW_SINGLE_LINE_TEXT));
        dispatch(setCommandMessage("Metni girin"));
      }
      if (tool === "mtext") {
        dispatch(setCommandType(COMMANDS.DRAW_MTEXT));
        dispatch(setCommandMessage("Metni girin"));
      }
    }
  };

  const updateTextOptions = () => {
    dispatch(setTextOptions({ font, fontSize, alignment, bold, italic, underline, color }));
  };

  useEffect(() => {
    updateTextOptions();
  }, [font, fontSize, alignment, bold, italic, underline, color]);

  return (
    <div className={`toolDrawText ${isOpen ? "open" : "closed"}`}>
      {isOpen && (
        <div className="toolText-left">
          <div className="toolTextRow">
            <button
              className={`toolTextButton ${activeButton === "singleLine" ? "active" : ""}`}
              style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
              onClick={() => handleClick("singleLine")}
            >
              {getIcon("text", buttonSize)}
              <span className="toolTextLabel">Single Line</span>
            </button>
            <button
              className={`toolTextButton ${activeButton === "mtext" ? "active" : ""}`}
              style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
              onClick={() => handleClick("mtext")}
            >
              {getIcon("mtext", buttonSize)}
              <span className="toolTextLabel">Mtext</span>
            </button>

            <button className={`styleToggle ${bold ? 'active' : ''}`} onClick={() => setBold(!bold)}>B</button>
            <button className={`styleToggle ${italic ? 'active' : ''}`} onClick={() => setItalic(!italic)}>I</button>
            <button className={`styleToggle ${underline ? 'active' : ''}`} onClick={() => setUnderline(!underline)}>U</button>
            <div className="toolTextButton" style={{ padding: 0, margin: 0 }}>
              <label className="toolTextLabel" style={{ padding: 0, margin: 0 }}>Color</label>
              <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                style={{ width: '100%', height: '30px', padding: 0, border: 'none' }}
              />
            </div>
          </div>

          <div className="toolTextRow">
            <div className="toolTextButtonFontType">
              <select value={font} onChange={(e) => setFont(e.target.value)} className="toolSelect">
                <option value="Arial">Arial</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Courier New">Courier New</option>
                <option value="Verdana">Verdana</option>
              </select>
            </div>

            <div className="toolTextButton">
              <label className="toolTextLabel">Font Size</label>
              <select value={fontSize} onChange={(e) => setFontSize(e.target.value)} className="toolSelect">
                <option value="10">10</option>
                <option value="12">12</option>
                <option value="14">14</option>
                <option value="16">16</option>
                <option value="18">18</option>
                <option value="20">20</option>
              </select>
            </div>

            <div className="toolTextButton">
              <label className="toolTextLabel">Alignment</label>
              <select value={alignment} onChange={(e) => setAlignment(e.target.value)} className="toolSelect">
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
          </div>
        </div>
      )}

  <div className="toolText-toggle">
    <button
      className="toolButton toggleArrowButton"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      {isOpen ? "◀" : "Text▶"}
    </button>
  </div>
    </div>
  );
};

export default ToolText;